import logoRaw from "../assets/sendcube-logo.svg?raw";
import emblemRaw from "../assets/sendcube-emblem.svg?raw";

// Mesma tecnica de recorte usada no app principal (frontend/src/components/ui/SendCubeLogo.tsx)
// - os SVGs originais tem viewBox de canvas inteiro com bastante margem morta, recortado aqui
// pras coordenadas reais do desenho.
function cropAndScale(svg: string, viewBox: string): string {
  return svg
    .replace(/viewBox="[^"]*"/, `viewBox="${viewBox}"`)
    .replace(/\swidth="[0-9.]+"/, "")
    .replace(/\sheight="[0-9.]+"/, "");
}

const LOGO_SVG = cropAndScale(logoRaw, "90 406 1635 344");
const EMBLEM_SVG = cropAndScale(emblemRaw, "66 214 1113 829");

interface LogoProps {
  className?: string;
}

// Os SVGs tem fundo branco opaco embutido no desenho - sempre envolvidos numa "plaqueta"
// branca fixa (nao muda com dark mode, este site nao tem modo escuro).
export function Logo({ className = "" }: LogoProps) {
  return (
    <div
      className={`inline-flex items-center justify-center rounded-lg bg-white px-2 py-1.5 [&>svg]:block [&>svg]:h-full [&>svg]:w-auto ${className}`}
      dangerouslySetInnerHTML={{ __html: LOGO_SVG }}
    />
  );
}

export function Emblem({ className = "" }: LogoProps) {
  return (
    <div
      className={`inline-flex items-center justify-center rounded-lg bg-white px-1.5 py-1.5 [&>svg]:block [&>svg]:h-full [&>svg]:w-auto ${className}`}
      dangerouslySetInnerHTML={{ __html: EMBLEM_SVG }}
    />
  );
}
